import { memo } from "react";
import firstLook from '/assets/images/srp/tagicons/firstLook.svg';
import hotProperty from '/assets/images/srp/tagicons/hotproperty.svg';
import selfshowing from '/assets/images/srp/tagicons/selfshowing.svg';
import signatureseller from '/assets/images/srp/tagicons/signatureseller.svg';
import ispreview from '/assets/images/srp/tagicons/ispreview.svg';
import isnobuyerpremium from '/assets/images/srp/tagicons/isnobuyerpremium.svg';
import reservemet from '/assets/images/srp/tagicons/reservemet.svg';
import pricereduced from '/assets/images/srp/tagicons/pricereduced.svg';
import proxyproperty from '/assets/images/srp/tagicons/proxyproperty.svg';

const TagIcon = ({tagName}) => { 
  if (tagName === 'firstLook') {
    return (
      <img src={firstLook} height={36} width={36} style={{minHeight: 36}} alt="fl" />
    );
  }
  if (tagName === 'isFcProxyBidEnabled') {
    return (
      <img src={proxyproperty} height={36} width={36} style={{minHeight: 36}} alt="pp" />
    );
  } if (tagName === 'hotProperty') {
    return (
      <img src={hotProperty} height={36} width={36} style={{minHeight: 36}} alt="hp" />
    );
  } if (tagName === 'reserveMet') {
    return (
      <img src={reservemet} height={36} width={36} style={{minHeight: 36}} alt="rm" />
    );
  } else if (tagName === 'isNoBuyerPremium') { 
    return (
      <img src={isnobuyerpremium} height={36} width={36} style={{minHeight: 36}} alt="nbp"/>
    )
  } 

  //Commenting as part of HUBZ-17900. we just need to show preview tag instead of icon.
  // else if (tagName === 'isPreview') { 
  //   return (
  //     <img src={ispreview} height={36} width={36} style={{minHeight: 36}} alt="preview"/>
  //   )
  // } 
  
  if (tagName === 'commercialProperty') {
    return <></>;
  } if (tagName === 'signatureSeller') {
    return (
      <img src={signatureseller} height={36} width={36} style={{minHeight: 36}} alt="sigS"/>
    );
  } if (tagName === 'selfShowing') {
    return (
      <img src={selfshowing} height={36} width={36} style={{minHeight: 36}} alt="selfS" />
    );
  } if (tagName === 'priceReduced') {
    return (
      <img src={pricereduced} height={36} width={36} style={{minHeight: 36}} alt="price"/>
    );
  } if (tagName === 'cwcotFLP') {
    return <></>;
  } else {
    return <></>;
  }
};

export default memo(TagIcon);